import { urlBuilder } from './builder';

export default urlBuilder(() => '/system-users/');
export const urlSystemUserCreate = urlBuilder(({ id = ':id' }: { id: string }) => `/system-users/${id}/create`);
export const urlSystemUserDetails = urlBuilder(({ id = ':id' }: { id: string }) => `/system-users/${id}/details`);
export const urlSystemUserEdit = urlBuilder(({ id = ':id' }: { id: string }) => `/system-users/${id}/edit`);
